import { gql } from "@apollo/client";

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser($userInput: UserInput!) {
    createUser(userInput: $userInput) {
      code
      data
      error {
        message
        correlationId
      }
    }
  }
`;

export const RELAUNCH_USER_MUTATION = gql`
  mutation RelaunchUser($userEmail: String!) {
    relaunchUser(userEmail: $userEmail) {
      code
      data
      error {
        message
        correlationId
      }
    }
  }
`;

export const MT_MANAGE_ATTACHMENT = gql`
  mutation ManageAttachment(
    $email: String!
    $personId: String!
    $listAttachmentRequest: ListAttachmentRequest!
  ) {
    MT_MANAGE_ATTACHMENT(
      email: $email
      personId: $personId
      listAttachmentRequest: $listAttachmentRequest
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        attachments {
          entityId
        }
      }
    }
  }
`;
